import { Component, Input, OnInit } from '@angular/core';
import { Options } from '@angular-slider/ngx-slider';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { DateTimePipe } from '../../pipe/date.pipe';
import { map } from 'rxjs/operators';

@Component({
  selector: 'lifedi-report-matching',
  templateUrl: './report-matching.component.html',
  styleUrls: ['./report-matching.component.scss'],
})
export class ReportMatchingComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;
  data_report;
  // data_report = [
  //   {
  //     reportname: 'รายงานแบบทดสอบ',
  //     measure_name: 'แบบทดสอบพัฒนา',
  //     report_description:
  //       'รอบการโคจรรอบดวงอาทิตย์ของโลกปรากฏการณ์ที่ทำให้เกิด การเปลี่ยนแปลงของสิ่งแวดล้อมในด้านแสงอุณหภูมิและการหาอาหารแตกต่างกันในช่วงกลางวันและกลางคืนสิ่งมีชีวิตบนโลกนี้ใช้จังหวะการโคจรรอบดวงอาทิตย์ของโลก',
  //     data: [
  //       {
  //         ideal_type: 'ideal#1',
  //         ideal_data: [
  //           {
  //             id: '0',
  //             psy_name: 'ทดสอบชื่อลักษณะทางจิตวิทยาหัวข้อ1หัวข้อใหญ่',
  //             psy_description:
  //               'รอบการโคจรรอบดวงอาทิตย์ของโลกปรากฏการณ์ที่ทำให้เกิดการเปลี่ยนแปลงของสิ่งแวดล้อมในด้านแสงอุณหภูมิ และการหาอาหารแตกต่างกันในช่วงกลางวันและกลางคืนสิ่งมีชีวิตบนโลกนี้ใช้จังหวะการโคจรรอบดวงอาทิตย์ของโลก 1',
  //             min: '0',
  //             max: '100',
  //             value: '50',
  //             ideal_value: '50',
  //             range: '3-5',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //             color: '#40559F',
  //           },
  //           {
  //             id: '1',
  //             psy_name: 'Fairness111',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 2',
  //             min: '0',
  //             max: '90',
  //             value: '10',
  //             ideal_value: '50',
  //             range: '3-5',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //             color: '#40559F',
  //           },
  //           {
  //             id: '2',
  //             psy_name: 'Fairness222',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 2',
  //             min: '0',
  //             max: '90',
  //             value: '90',
  //             ideal_value: '50',
  //             range: '3-5',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //             color: '#40559F',
  //           },
  //         ],
  //       },
  //       {
  //         ideal_type: 'ideal#2',
  //         ideal_data: [
  //           {
  //             id: '3',
  //             psy_name: 'Fairness333',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 3',
  //             min: '0',
  //             max: '70',
  //             value: '50',
  //             ideal_value: '50',
  //             range: '3-5',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //             color: '#40559F',
  //           },
  //           {
  //             id: '4',
  //             psy_name: 'Fairness444',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 4',
  //             min: '0',
  //             max: '80',
  //             value: '10',
  //             ideal_value: '50',
  //             range: '3-5',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //             color: '#40559F',
  //           },
  //           {
  //             id: '5',
  //             psy_name: 'Fairness555',
  //             psy_description: 'คำอธิบายลักษณะทางจิตวิทยา 4',
  //             min: '0',
  //             max: '80',
  //             value: '10',
  //             ideal_value: '50',
  //             range: '3-5',
  //             range_description:
  //               'ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบายอาจจะบังคับ 500 ตัว (ดูตามความเหมาะสมให้ด้วย) 200 ในคำอธิบาย Lock จำนวน text คำอธิบาย',
  //             color: '#40559F',
  //           },
  //         ],
  //       },
  //     ],
  //   },
  // ];
  value: number = 10;
  highValue: number = 50;
  options: Options[] = [];

  constructor(private measureService: MeasureService) { }
  isLoading: boolean;

  ngOnInit(): void {
    this.isLoading = true;
    setTimeout(() => { }, 1000);
    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }
    this.measureService
      .getReportByMeasureId(body)
      .pipe(
        map(async (res) => {
          this.data_report = [res.result];
          // console.log(this.data_report);
          for (let i = 0; i < this.data_report[0].data.length; i++) {
            for (
              let j = 0;
              j < this.data_report[0].data[i].ideal_data.length;
              j++
            ) {
              this.options.push({
                floor: +this.data_report[0].data[i].ideal_data[j].min,
                ceil: +this.data_report[0].data[i].ideal_data[j].max,
                disabled: true,
              });
            }
          }
          //// console.log(this.options);
          //await this.filepdf();
          setTimeout(() => {
            this.filepdf();
          }, 1000);
          this.isLoading = false;
        })
      )
      .subscribe();


  }

  sliderOptions(min, max): Options {
    return {
      floor: +min,
      ceil: +max,
    };
  }

  // FloorCeil(min, max) {
  //   return {
  //     floor: +min,
  //     ceil: +max,
  //   };
  // }

  downloadpdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let username = this.data_report[0].username;
    this.isLoading = true;
    let alldata = this.data_report;
    let allPage;
    let NewArray = [];

    let num_slider = this.data_report[0].data[0].ideal_data.length;

    for (let i = 0; i < alldata[0].data.length; i++) {
      for (let j = 0; j < alldata[0].data[i].ideal_data.length; j++) {
        let a = document.getElementById(
          'sliderpdf' + alldata[0].data[i].ideal_data[j].id
        );
        NewArray.push(a);
      }
    }
    // console.log(NewArray);

    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        dataArray[0];
        let img1 = new Image();
        img1.src = dataArray[0];
        // console.log(dataArray[0]);

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };

        allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text: username + ' ( userid : ' + userid + ' )' + '  | ' + formattedDate + ' หน้า ' + currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 24,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              text: this.data_report[0].data[0].ideal_type,
              alignment: 'center',
              fontSize: 22,
              decoration: 'underline',
              color: '#000000',
              margin: [0, 10],
              bold: true,
              pageBreak: '',
            },

            {
              columns: [
                {
                  text: this.data_report[0].data[0].ideal_data[0].psy_name,
                  alignment: 'left',
                  fontSize: 14,
                  decoration: 'underline',
                  color: '#060e9f',
                  margin: [0, 10, 20, 0],
                  bold: true,
                  width: 150,
                },
                {
                  image: dataArray[0],
                  width: 220,
                  height: 50,
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                },
                [
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[0].ideal_data[0].value).toFixed(2) +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#060e9f',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                  {
                    text:
                      'คะแนนที่เหมาะสม ' +
                      this.data_report[0].data[0].ideal_data[0].ideal_value +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#ffc90e',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let j = 1; j < alldata[0].data[0].ideal_data.length; j++) {
          allPage.content.push({
            columns: [
              {
                text: this.data_report[0].data[0].ideal_data[j].psy_name,
                alignment: 'left',
                fontSize: 14,
                decoration: 'underline',
                color: '#060e9f',
                margin: [0, 10, 20, 0],
                bold: true,
                width: 150,
              },
              {
                image: dataArray[j],
                width: 220,
                height: 50,
                alignment: 'center',
                margin: [0, 15, 0, 0],
              },
              [
                {
                  text:
                    'ท่านได้ ' +
                    parseFloat(this.data_report[0].data[0].ideal_data[j].value).toFixed(2) +
                    ' คะแนน',
                  fontSize: 14,
                  color: '#060e9f',
                  margin: [20, 5, 0, 0],
                  bold: true,
                },
                {
                  text:
                    'คะแนนที่เหมาะสม ' +
                    this.data_report[0].data[0].ideal_data[j].ideal_value +
                    ' คะแนน',
                  fontSize: 14,
                  color: '#ffc90e',
                  margin: [20, 5, 0, 0],
                  bold: true,
                },
              ],
            ],
            // columnGap: 5,
          });
        }
        for (let i = 1; i < alldata[0].data.length; i++) {
          allPage.content.push({
            text: this.data_report[0].data[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            decoration: 'underline',
            color: '#000000',
            margin: [0, 10],
            bold: true,
            pageBreak: '',
          });
          for (let j = 0; j < alldata[0].data[i].ideal_data.length; j++) {
            allPage.content.push({
              columns: [
                {
                  text: this.data_report[0].data[i].ideal_data[j].psy_name,
                  alignment: 'left',
                  fontSize: 14,
                  decoration: 'underline',
                  color: '#060e9f',
                  margin: [0, 10, 20, 0],
                  bold: true,
                  width: 150,
                },
                {
                  image: dataArray[num_slider],
                  width: 220,
                  height: 50,
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                },
                [
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[i].ideal_data[j].value).toFixed(2) +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#060e9f',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                  {
                    text:
                      'คะแนนที่เหมาะสม ' +
                      this.data_report[0].data[i].ideal_data[j].ideal_value +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#ffc90e',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            });
            num_slider++;
          }
        }
        for (let i = 0; i < alldata[0].data.length; i++) {
          allPage.content.push({
            text: this.data_report[0].data[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            color: '#000000',
            decoration: 'underline',
            margin: [0, 10],
            bold: true,
            pageBreak: 'before',
          });
          for (let j = 0; j < alldata[0].data[i].ideal_data.length; j++) {
            allPage.content.push(
              {
                text: this.data_report[0].data[i].ideal_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: '#060e9f',
                margin: [0, 20, 0, 0],
                bold: true,
              },
              {
                text: this.data_report[0].data[i].ideal_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'คะแนนต่ำสุด : ' +
                  this.data_report[0].data[i].ideal_data[j].min +
                  '    คะแนนสูงสุด : ' +
                  this.data_report[0].data[i].ideal_data[j].max,
                alignment: 'left',
                fontSize: 18,
                color: '#000000',
                margin: [0, 10, 0, 0],
                bold: true,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(this.data_report[0].data[i].ideal_data[j].value).toFixed(2) +
                  ' คะแนน',
                  // ' อยู่ในช่วงคะแนน ' +
                  // this.data_report[0].data[i].ideal_data[j].range +
                  // ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: '#060e9f',
                margin: [0, 5, 0, 0],
                bold: true,
              },
              {
                text: this.data_report[0].data[i].ideal_data[j]
                  .range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                bold: false,
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 30],
                bold: false,
              }
            );
          }
        }
        // console.log(allPage);

        pdfMake.createPdf(allPage).open();
        this.isLoading = false;
      }
    );
  }

  async filepdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let alldata = this.data_report;
    let allPage;
    let NewArray = [];

    let num_slider = this.data_report[0].data[0].ideal_data.length;

    for (let i = 0; i < alldata[0].data.length; i++) {
      for (let j = 0; j < alldata[0].data[i].ideal_data.length; j++) {
        let a = document.getElementById(
          'sliderpdf' + alldata[0].data[i].ideal_data[j].id
        );
        NewArray.push(a);
      }
    }
    // console.log(NewArray);

    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        dataArray[0];
        let img1 = new Image();
        img1.src = dataArray[0];
        // console.log(dataArray[0]);

        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };

        allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  userid +
                  ' | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 24,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              text: this.data_report[0].data[0].ideal_type,
              alignment: 'center',
              fontSize: 22,
              decoration: 'underline',
              color: '#000000',
              margin: [0, 10],
              bold: true,
              pageBreak: '',
            },

            {
              columns: [
                {
                  text: this.data_report[0].data[0].ideal_data[0].psy_name,
                  alignment: 'left',
                  fontSize: 14,
                  decoration: 'underline',
                  color: '#060e9f',
                  margin: [0, 10, 20, 0],
                  bold: true,
                  width: 150,
                },
                {
                  image: dataArray[0],
                  width: 220,
                  height: 50,
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                },
                [
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[0].ideal_data[0].value).toFixed(2) +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#060e9f',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                  {
                    text:
                      'คะแนนที่เหมาะสม ' +
                      this.data_report[0].data[0].ideal_data[0].ideal_value +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#ffc90e',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let j = 1; j < alldata[0].data[0].ideal_data.length; j++) {
          allPage.content.push({
            columns: [
              {
                text: this.data_report[0].data[0].ideal_data[j].psy_name,
                alignment: 'left',
                fontSize: 14,
                decoration: 'underline',
                color: '#060e9f',
                margin: [0, 10, 20, 0],
                bold: true,
                width: 150,
              },
              {
                image: dataArray[j],
                width: 220,
                height: 50,
                alignment: 'center',
                margin: [0, 15, 0, 0],
              },
              [
                {
                  text:
                    'ท่านได้ ' +
                    parseFloat(this.data_report[0].data[0].ideal_data[j].value).toFixed(2) +
                    ' คะแนน',
                  fontSize: 14,
                  color: '#060e9f',
                  margin: [20, 5, 0, 0],
                  bold: true,
                },
                {
                  text:
                    'คะแนนที่เหมาะสม ' +
                    this.data_report[0].data[0].ideal_data[j].ideal_value +
                    ' คะแนน',
                  fontSize: 14,
                  color: '#ffc90e',
                  margin: [20, 5, 0, 0],
                  bold: true,
                },
              ],
            ],
            // columnGap: 5,
          });
        }
        for (let i = 1; i < alldata[0].data.length; i++) {
          allPage.content.push({
            text: this.data_report[0].data[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            decoration: 'underline',
            color: '#000000',
            margin: [0, 10],
            bold: true,
            pageBreak: '',
          });
          for (let j = 0; j < alldata[0].data[i].ideal_data.length; j++) {
            allPage.content.push({
              columns: [
                {
                  text: this.data_report[0].data[i].ideal_data[j].psy_name,
                  alignment: 'left',
                  fontSize: 14,
                  decoration: 'underline',
                  color: '#060e9f',
                  margin: [0, 10, 20, 0],
                  bold: true,
                  width: 150,
                },
                {
                  image: dataArray[num_slider],
                  width: 220,
                  height: 50,
                  alignment: 'center',
                  margin: [0, 15, 0, 0],
                },
                [
                  {
                    text:
                      'ท่านได้ ' +
                      parseFloat(this.data_report[0].data[i].ideal_data[j].value).toFixed(2) +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#060e9f',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                  {
                    text:
                      'คะแนนที่เหมาะสม ' +
                      this.data_report[0].data[i].ideal_data[j].ideal_value +
                      ' คะแนน',
                    fontSize: 14,
                    color: '#ffc90e',
                    margin: [20, 5, 0, 0],
                    bold: true,
                  },
                ],
              ],
              // columnGap: 5,
            });
            num_slider++;
          }
        }
        for (let i = 0; i < alldata[0].data.length; i++) {
          allPage.content.push({
            text: this.data_report[0].data[i].ideal_type,
            alignment: 'center',
            fontSize: 22,
            color: '#000000',
            decoration: 'underline',
            margin: [0, 10],
            bold: true,
            pageBreak: 'before',
          });
          for (let j = 0; j < alldata[0].data[i].ideal_data.length; j++) {
            allPage.content.push(
              {
                text: this.data_report[0].data[i].ideal_data[j].psy_name,
                alignment: 'left',
                fontSize: 18,
                decoration: 'underline',
                color: '#060e9f',
                margin: [0, 20, 0, 0],
                bold: true,
              },
              {
                text: this.data_report[0].data[i].ideal_data[j].psy_description,
                alignment: 'left',
                fontSize: 14,
                decoration: '',
                color: '#000000',
                margin: [0, 10, 0, 0],
                pageBreak: '',
                bold: false,
              },
              {
                text:
                  'คะแนนต่ำสุด : ' +
                  this.data_report[0].data[i].ideal_data[j].min +
                  '    คะแนนสูงสุด : ' +
                  this.data_report[0].data[i].ideal_data[j].max,
                alignment: 'left',
                fontSize: 18,
                color: '#000000',
                margin: [0, 10, 0, 0],
                bold: true,
              },
              {
                text:
                  'ท่านได้ ' +
                  parseFloat(this.data_report[0].data[i].ideal_data[j].value).toFixed(2) +
                  ' คะแนน',
                  // ' อยู่ในช่วงคะแนน ' +
                  // this.data_report[0].data[i].ideal_data[j].range +
                  // ' คะแนน',
                alignment: 'left',
                fontSize: 18,
                color: '#060e9f',
                margin: [0, 5, 0, 0],
                bold: true,
              },
              {
                text: this.data_report[0].data[i].ideal_data[j]
                  .range_description,
                alignment: 'left',
                fontSize: 14,
                color: '#000000',
                margin: [0, 10, 0, 10],
                bold: false,
              },
              {
                text: '_____________________________________________________________________________________________',
                alignment: 'center',
                fontSize: 10,
                color: 'gray',
                margin: [0, 10, 0, 30],
                bold: false,
              }
            );
          }
        }
        var pdfDocGenerator = pdfMake.createPdf(allPage);
        pdfDocGenerator.getBase64((base64str) => {
          // console.log(base64str);
          let data = {
            MEASURE_ID: this.measureid,
            TYPE: this.type,
            base64str: base64str,
            view: this.view_status,
          };
          this.measureService.SaveReportMeasureId(data).subscribe((res) => {
            // console.log(res);
          });
        });
      }
    );
  }
}
